'use client';
import { watchBlocks, } from '@wagmi/core';
import {} from '@wagmi/core/internal';
import { useEffect } from 'react';
import { useChainId } from './useChainId.js';
import { useConfig } from './useConfig.js';
/** https://wagmi.sh/react/hooks/useWatchBlocks */
export function useWatchBlocks(parameters = {}) {
    const { enabled = true, onBlock, config: _, ...rest } = parameters;
    const config = useConfig(parameters);
    const configChainId = useChainId({ config });
    const chainId = parameters.chainId ?? configChainId;
    useEffect(() => {
        if (!enabled)
            return;
        if (!onBlock)
            return;
        return watchBlocks(config, {
            ...rest,
            chainId,
            onBlock,
        });
    }, [chainId, config, enabled, onBlock, rest]);
}
//# sourceMappingURL=useWatchBlocks.js.map